const applyProductLabelColors = () => {
  document.querySelectorAll('[data-product-gallery-label]').forEach((label) => {
    const backgroundColor = label.getAttribute('data-label-background-color');
    const textColor = label.getAttribute('data-label-text-color');

    if (backgroundColor) {
      label.style.setProperty('--product-gallery-label-bg', backgroundColor);
    }

    if (textColor) {
      label.style.setProperty('--product-gallery-label-color', textColor);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyProductLabelColors);
} else {
  applyProductLabelColors();
}

export default applyProductLabelColors;



// WEBPACK FOOTER //
// ./scripts/global/product-labels.js